/* istanbul ignore file */
import { brandName } from 'config';

export default defineNuxtPlugin(() => {
  const route = useRoute();
  const seo = route.meta?.seo;

  if (!seo) return;

  const meta = [];
  const link = [];

  if (seo.description) {
    meta.push({ name: 'description', content: seo.description });
  }

  if (!seo.index) {
    meta.push({ name: 'robots', content: 'noindex, nofollow' });
  }

  if (seo.link) {
    link.push({ rel: 'canonical', href: seo.link });
  }

  useHead({
    title: `${seo.title} - ${brandName}`,
    meta,
    link,
  });
});
